<template>
  <base-data-table
    :items="highRiskAlertSupports"
    title="アラート"
    header-icon="mdi-clock-alert-outline"
    :column-widths="['160px', '140px', '', '140px', '', '120px']"
  >
    <template #header-cells>
      <th>アラート発生日時</th>
      <th>アラート種別</th>
      <th>アラート補足</th>
      <th>方針</th>
      <th>方針補足</th>
      <th />
    </template>
    <template #cells="{ row: alertSupport }">
      <td>{{ alertSupport.alertedAt }}</td>
      <td>{{ alertSupport.alertType }}</td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ alertSupport.alertNote }}
        </div>
      </td>
      <td>
        <v-chip
          v-if="alertSupport.policy"
          :class="alertSupport.policyClass"
          size="x-small"
          variant="flat"
        >
          {{ alertSupport.policy }}
        </v-chip>
      </td>
      <td>
        <div class="base-data-table-two-line-clamp">
          {{ alertSupport.policyNote }}
        </div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('open-detail', alertSupport)"
        >
          詳細を開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetHighRiskAlertSupportTable",
  components: {
    BaseDataTable
  },
  props: {
    highRiskAlertSupports: {
      type: Array,
      default: () => []
    }
  },
  emits: ["open-detail"]
};
</script>

<style lang="scss" scoped>
.pending-policy-chip {
  background-color: #f2f2f2;
  color: rgba(0, 0, 0, 0.6);
  font-weight: bold;
}

.consent-mail-chip {
  background-color: #ffe7ec;
  color: #ef5d7a;
  font-weight: bold;
}
</style>
